export const columns = [
  {
    name: "City",
    accessor: "location_html",
  },
];
